import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Flexbox from 'flexbox-react';
import { Collapse } from 'antd';
import Constants from 'utils/Constants';
import ComponentUtils from "utils/ComponentUtils";
import $ from "jquery";

export default class SecondsInput extends React.Component {
    static propTypes = {
        value: PropTypes.any,
        className: PropTypes.string,
        fieldPath: PropTypes.string,
        editProps: PropTypes.object,
        onChange: PropTypes.func,
        units: PropTypes.string
    };

    static defaultProps = {
        units: 'seconds'
    };

    constructor(props) {
        super(props);
        this.calculateSeconds = this.calculateSeconds.bind(this);

        this.state = {
            newValue: null,
            activeKey: []
        };
    }

    /**
     * Components should be storing the new value in their state as the component is modified.
     */
    getNewValue = () => {
        // return the latest state set by the component widgets, or
        // the latest the original props.value if nothing has changed
        if (this.state.newValue !== null && this.state.newValue !== undefined) {
            return this.state.newValue;
        } else {
            return this.props.value;
        }
    };

    calculateSeconds = () => {
        let secondsValue = 0;
        const numOfSecondsInput = this.refs.numOfSecondsInput.value;
        const intervalUnits = this.refs.intervalUnits.value;
        //this is a case where i do NOT want === to test equality
        // eslint-disable-next-line
        if (numOfSecondsInput == parseFloat(numOfSecondsInput)) {
            switch (intervalUnits) {
                case 'hour':
                    secondsValue = Constants.SECONDS_IN_HOUR;
                    break;
                case 'day':
                    secondsValue = Constants.SECONDS_IN_DAY;
                    break;
                case 'week':
                    secondsValue = Constants.SECONDS_IN_WEEK;
                    break;

                default:
                    break;
            }

            this.refs.numOfSecondsOutput.value = secondsValue * numOfSecondsInput;
            return secondsValue * numOfSecondsInput;
        }
        return null;
    };

    applyCalculation = () => {
        const calculated = this.calculateSeconds();
        if (calculated !== null) {
            this.setState({ newValue: calculated, activeKey: [] });
            this.props.onChange(this.props.fieldPath, calculated);
        }
    };

    textChanged = (event) => {
        const newValue = event.target.value.trim();
        this.setState({ newValue });
        this.props.onChange(this.props.fieldPath, newValue);
    };

    highlightComponentText = () => {
        const inputElem = ReactDOM.findDOMNode(this.refs.input);
        if (inputElem) {
            inputElem.focus();
            // element.setSelectionRange won't work for an input of type "number"
            setTimeout(() => { inputElem.select(); }, 10);
        }
    };

    onCollapseChange = (activeKey) => {
        if (activeKey[0] === 'calculator') {
            const getComponent = () => {
                let comp =  $(ReactDOM.findDOMNode(this));
                // we want to use the ant-collapse-content component for sizing
                comp = comp.find('.ant-collapse-content');
                return comp;
            }

            setTimeout(() => {
                ComponentUtils.scrollComponentIntoView(getComponent);
            }, 10);
        }

        this.setState({ activeKey });
    };

    render = () => {
        const value = this.getNewValue() || '';
        let annotation = this.props.units;
        if (value && annotation === 'seconds') {
            annotation = `seconds ${Constants.getSecondsDescriptiveLabel(value)}`;
        }
        return (
            <div
                tabIndex="1"
                className={`seconds-input ${this.props.className}`}
                {...this.props.editProps}
            >
                <Flexbox flexDirection="row" alignItems="baseline" marginLeft="5px" marginBottom="5px">
                    <input
                        ref="input"
                        size="7"
                        type="number"
                        value={value}
                        onChange={this.textChanged}
                        style={ { marginTop: '5px', width: '70px' } }
                    />
                    <Flexbox marginLeft="5px" marginTop="5px">
                        <div>{annotation}</div>
                    </Flexbox>
                </Flexbox>
                <Collapse activeKey={this.state.activeKey} onChange={this.onCollapseChange}>
                    <Collapse.Panel header="Calculate Seconds" key="calculator" forceRender>
                        <Flexbox flexDirection="column" alignItems="flex-start">
                            <Flexbox flexDirection="row" alignItems="center" marginBottom="7px">
                                <input
                                    ref="numOfSecondsInput"
                                    type="number"
                                    size="6"
                                    step="0.1"
                                    onKeyUp={this.calculateSeconds}
                                    style={ { width: '20%' } }
                                />
                                <select ref="intervalUnits" onChange={this.calculateSeconds}>
                                    <option value="hour">Hour(s)</option>
                                    <option value="day">Day(s)</option>
                                    <option value="week">Week(s)</option>
                                </select>
                                <div style={ { margin: '0 5px', fontWeight: 'bold', fontSize: '18px' } }>=</div>
                                <input
                                    ref="numOfSecondsOutput"
                                    size="15"
                                    style={ { width: '30%' } }
                                    disabled
                                />
                                <div style={ { marginLeft: '3px' } }>seconds</div>
                            </Flexbox>
                            <Flexbox flexDirection="row-reverse" justifyContent="flex-end">
                                <button
                                    className="btn"
                                    type="button"
                                    onClick={this.applyCalculation}
                                    title="Apply"
                                >
                                    Ok
                                </button>
                            </Flexbox>
                        </Flexbox>
                        <span ref="calcView"/>
                    </Collapse.Panel>
                </Collapse>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/editable/SecondsInput.js